import React from 'react';

interface IProps {
  size?: string;
  color?: string;
}

const StarIcon: React.FC<IProps> = ({ size = '18', color = 'text-orange-400' }: { size?: string; color?: string }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    className={`h-[${size}px] w-[${size}px] ${color}`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.30404 12C4.38654 11.6325 4.23654 11.1075 3.97404 10.845L2.15154 9.0225C1.58154 8.4525 1.35654 7.845 1.52154 7.32C1.69404 6.795 2.22654 6.435 3.02154 6.3L5.36154 5.91C5.69904 5.85 6.11154 5.55 6.26904 5.2425L7.55904 2.655C7.93404 1.9125 8.44404 1.5 8.99904 1.5C9.55404 1.5 10.064 1.9125 10.439 2.655L11.729 5.2425C11.8265 5.4375 12.029 5.625 12.2465 5.7525L4.16904 13.83C4.06404 13.935 3.88404 13.8375 3.91404 13.6875L4.30404 12Z"
      fill="currentColor"
    />
    <path
      d="M13.6273 14.3916L13.6276 14.3931C13.8309 15.2693 13.6349 15.6367 13.478 15.7513C13.4063 15.8027 13.3084 15.84 13.1546 15.84C12.9154 15.84 12.5719 15.7481 12.1331 15.4889C12.1328 15.4888 12.1326 15.4886 12.1323 15.4885L9.93597 14.1842L9.93598 14.1841L9.93333 14.1826C9.64607 14.014 9.30537 13.9482 8.99961 13.9482C8.69384 13.9482 8.35314 14.014 8.06589 14.1826L8.06589 14.1826L8.06324 14.1842L5.86892 15.4873C5.86843 15.4876 5.86795 15.4879 5.86746 15.4881C5.14933 15.9083 4.74562 15.8757 4.56741 15.7808L13.3314 7.01681C13.5417 6.80652 13.8337 6.71555 14.1089 6.76361L14.1125 6.76422L14.8692 6.89158C14.8693 6.8916 14.8695 6.89163 14.8696 6.89165C15.5561 7.00832 15.8237 7.28232 15.8984 7.50362C15.9656 7.72396 15.9069 8.10672 15.4153 8.59828L15.4145 8.59916L13.6003 10.4208C13.6001 10.421 13.5999 10.4212 13.5997 10.4214C13.3764 10.645 13.2285 10.9395 13.1479 11.2205C13.0678 11.4996 13.036 11.8283 13.1106 12.1378L13.6273 14.3916Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.2"
    />
  </svg>
);

export default StarIcon;
